import React from 'react';

const answerKey = ['A', 'B', 'C', 'D', 'E'];

function Question({ data, select, pickAnswer, ...props }) {
  return (
    <div className="mb-6 px-4 py-5 rounded-2xl bg-white">
      <h4 className="text-[#878789] text-[14px]">{'Câu ' + data.id}</h4>
      <p
        className="text-[12px] py-5"
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
      <div>
        {answerKey.map((key, index) => {
          return (
            <div
              key={index}
              className={`font-[700] rounded-xl p-3 bg-white mt-3 border border-1 border-gray-300 text-[12px] ${
                select === key && '!bg-[#99F0EF40] !border-none'
              }`}
              onClick={() => pickAnswer({ id: data.id, key })}
            >
              <p
                className="inline text-left cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: ParseAnswer(
                    [data.A, data.B, data.C, data.D, data.E][
                      answerKey.indexOf(key)
                    ],
                    key
                  ),
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default React.memo(Question);

export const ParseAnswer = (answer, key) => {
  return answer.slice(0, 3) + `${key}. ` + answer.slice(3);
};
